/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Content_Text } from "../Component/theme";
import Logo_Linkcampus from "../image/Logo_Linkcampus.png";
import Logo_Linkcampus2 from "../image/Logo_Linkcampus2.png";
import { useNavigate } from "react-router-dom";
import img_Info from "../image/img_Info2.png";

import img_process from "../image/img_process_2.png";
import img_process2 from "../image/img_process2_2.png";
import img_process3 from "../image/img_process3_2.png";

import Apply_Modal from "../Component/Apply_Modal";
import Apply_Modal2 from "../Component/Apply_Modal";
import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import Side_Live from "./Side_Live";
import Footer_Live from "./Footer_Live";
import Header_Live from "./Header_Live";
const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 85px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #f1f1f1;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 10;
  @media (max-width: 800px) {
    padding-left: 15px;
  }
`;
const Header_div = styled.div`
  display: flex;
  color: black;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  padding: 15px 20px;
`;
const Logo_img = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  margin-right: 50px;
  height: 40px;
  @media (max-width: 800px) {
    margin-right: 30px;
    height: 20px;
  }
`;
const Top_Button = styled.span`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  font-size: 20px;
  margin-left: 30px;
  cursor: pointer;
  color: #c0c0c0;
  transition: color 0.2s ease;
  &:hover {
    color: black;
  }
  @media (max-width: 800px) {
    font-size: 12px;
    margin-left: 15px;
  }
`;
const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
`;
const Main_init_div2 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
  }
`;
const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 850px;
  justify-self: center;
  @media (max-width: 800px) {
    width: 90%;
  }
`;
const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;
const Footer_Text = styled(Content_Text)`
  margin-top: 5px;
`;

const Footer_Bar = styled.div`
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  width: 1280px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;
const Footer_div = styled.div`
  justify-self: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 20%;
  @media (max-width: 800px) {
    width: 40%;
  }
`;
const Footer_Text2 = styled(Content_Text)`
  transition: color 0.2s ease;

  &:hover {
    color: #33cccc;
  }
`;

const UnderLine = styled.div`
  position: absolute;
  bottom: 0px;
  width: 70px;
  height: 2px;
  background-color: black;
  @media (max-width: 800px) {
    width: 41px;
    height: 1px;
  }
`;

const Main_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  background-color: white;
`;

const Main_div7 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  background-color: white;
  margin-top: 50px;
  @media (max-width: 800px) {
    margin-top: 0px;
  }
`;

const Process_IMG = styled(Image)`
  display: flex;
  @media (max-width: 1500px) {
    display: none;
  }
`;
const Process_IMG2 = styled(Image)`
  display: none;
  @media (max-width: 1500px) {
    display: flex;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;
const Process_IMG3 = styled(Image)`
  display: none;
  @media (max-width: 800px) {
    display: flex;
  }
`;

function Process_Live() {
  const navigation = useNavigate();
  const [stan_modal, set_Stan_Modal] = useState(false);
  const [pre_modal, set_Pre_Modal] = useState(false);
  const close_Stan_Modal = () => set_Stan_Modal(false);
  const close_Pre_Modal = () => set_Pre_Modal(false);
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const open_privacy_policy = () => set_Privacy_Policy(true);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const open_terms = () => set_Terms(true);
  const close_terms = () => set_Terms(false);
  const go_Home = () => {
    navigation("/FMS/");
    window.scrollTo({ top: 0 });
  };
  const go_About = () => {
    navigation("/FMS/about");
    window.scrollTo({ top: 0 });
  };
  // eslint-disable-next-line no-unused-vars
  const go_Platform = () => {
    navigation("/FMS/Platform");
    window.scrollTo({ top: 0 });
  };
  const go_Info = () => {
    navigation("/FMS/Info");
    window.scrollTo({ top: 0 });
  };
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 사이즈 체크
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_Live page={"프로세스"} />
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Main_div7>
          <Main_init_div2>
            <Main_Content>
              <Content_Text $xbold $xxlarge style={{ marginBottom: 4 }}>
                제작 프로세스
              </Content_Text>
              <Content_Text>기역기역의 서비스 절차입니다.</Content_Text>
            </Main_Content>
          </Main_init_div2>
        </Main_div7>
        <Main_div2>
          <Main_init_div>
            <Main_Content>
              <Process_IMG
                style={{
                  width: "100%",
                  justifySelf: "center",
                  marginBottom: 60,
                }}
                src={img_process}
                alt={img_process}
              />
              <Process_IMG2
                style={{
                  width: "100%",
                  justifySelf: "center",
                  marginBottom: 60,
                }}
                src={img_process2}
                alt={img_process2}
              />
              <Process_IMG3
                style={{
                  width: "100%",
                  justifySelf: "center",
                  marginBottom: 60,
                }}
                src={img_process3}
                alt={img_process3}
              />
            </Main_Content>
          </Main_init_div>
        </Main_div2>
        <Main_div2>
          <Main_init_div style={{ paddingTop: 0 }}>
            <Main_Content $left>
              <Content_Text $blue2 $xbold>
                <Content_Text $blue2 $xbold $large>
                  I{" "}
                </Content_Text>
                제작문의
              </Content_Text>
              <Content_Text $small style={{ marginTop: 10 }}>
                문의를 주시기 전, 참고하시는 벤치마킹 앱 또는 사이트를 기입하여
                주시거나 없으실 경우 간략하게 서비스 제작 방향과 함께 문의하여
                주시면 원활한 견적상담이 가능합니다.
              </Content_Text>
              <Content_Text $blue2 $xbold style={{ marginTop: 50 }}>
                <Content_Text $blue2 $xbold $large>
                  I{" "}
                </Content_Text>
                견적상담
              </Content_Text>
              <Content_Text $small style={{ marginTop: 10 }}>
                전화, 이메일을 통해 제작문의를 받은 후 고객님의 원하시는 서비스
                제작 방향을 듣습니다. 간략한 서비스 컨셉과 서비스에 들어가는
                개발 기능, 디자인 등을 종합적으로 검토하여 견적을 보내드립니다.
              </Content_Text>
              <Content_Text $blue2 $xbold style={{ marginTop: 50 }}>
                <Content_Text $blue2 $xbold $large>
                  I{" "}
                </Content_Text>
                계약 및 서비스 기획
              </Content_Text>
              <Content_Text $small style={{ marginTop: 10 }}>
                계약이 완료된 후, 고객님의 사업자료들을 전달받고 이를 바탕으로
                프로젝트를 진행하게 됩니다. 먼저 진행되는 단계는 서비스 기획으로
                서비스에 필요한 프로세스 및 스토리보드를 작성합니다. 서비스
                기획은 서비스의 틀이 되는 부분으로 가장 중요한 단계라고 할 수
                있습니다. 고객님과의 상호 피드백이 원활할수록 프로젝트가 빠르게
                진행될수있다는 점을 명시하여 주시기바랍니다.
              </Content_Text>
              <Content_Text $blue2 $xbold style={{ marginTop: 50 }}>
                <Content_Text $blue2 $xbold $large>
                  I{" "}
                </Content_Text>
                디자인 및 퍼블리싱
              </Content_Text>
              <Content_Text $small style={{ marginTop: 10 }}>
                확정된 기획서를 바탕으로 고객님이 원하시는 컬러와 벤치마킹
                사이트 등을 종합적으로 검토하여 디자이너가 메인디자인 시안을
                제공합니다. 메인디자인 컨펌이 완료되면 이후 서브페이지
                디자인작업이 들어가며, 작업이 완료된 디자인페이지를 바탕으로
                퍼블리싱 작업이 진행됩니다.
              </Content_Text>
              <Content_Text $blue2 $xbold style={{ marginTop: 50 }}>
                <Content_Text $blue2 $xbold $large>
                  I{" "}
                </Content_Text>
                개발 및 검수/수정
              </Content_Text>
              <Content_Text $small style={{ marginTop: 10 }}>
                견적서 및 확정된 기획서 등을 바탕으로 서비스에 들어가는 기능들을
                개발자가 검토 후 개발을 진행합니다. 모든 개발이 완료되면
                프로그램 및 기능이 제대로 구현, 작동하는지 검수 및 테스트 작업을
                진행합니다.
              </Content_Text>
              <Content_Text $blue2 $xbold style={{ marginTop: 50 }}>
                <Content_Text $blue2 $xbold $large>
                  I{" "}
                </Content_Text>
                서비스 오픈
              </Content_Text>
              <Content_Text $small style={{ marginTop: 10, marginBottom: 100 }}>
                사용하려는 도메인과 서버를 연결하여 서비스 오픈을 진행합니다.
              </Content_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div2>
        <Side_Live />
      </Main>
      <Footer>
        <Footer_Live />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
      <Apply_Modal show={stan_modal} onClose={close_Stan_Modal} data={"stan"} />
      <Apply_Modal2 show={pre_modal} onClose={close_Pre_Modal} data={"pre"} />
    </Container>
  );
}

export default Process_Live;
